import React from 'react';
import EllipsesControl from '../../../../Common/EllipsesControl/EllipsesControl';
import {MotifIcon, MotifIconButton} from '@ey-xd/motif-react';
import {IconoirTrash} from '@ey-xd/motif-icon';
import {labels} from '../../../../../util/uiconstants';

function RoleRow(props) {
	return (
		<section className={`manageaccessitemview`}>
			<section className="userlistitem grid motif-body2-default-light">
				<EllipsesControl
					content={props.data.moduleName}
					tooltip={props.data.moduleName}
					displayId={''}
					noOfLines={1}
					ellipsisClass="columnName"
				/>
			</section>
			<section className="userlistitem grid motif-body2-default-light">
				<EllipsesControl
					content={props.data.roleName}
					tooltip={props.data.roleName}
					displayId={''}
					noOfLines={1}
					ellipsisClass="columnName"
				/>
			</section>
			<section className="userlistitem grid motif-body2-default-light">
				<EllipsesControl
					content={props.data.subServiceLineName}
					tooltip={props.data.subServiceLineName}
					displayId={''}
					noOfLines={1}
					ellipsisClass="columnName"
				/>
			</section>
			<section className="userlistitem grid motif-body2-default-light">
				<EllipsesControl
					content={props.data.localizedCountries?.map((c) => c.name).join(', ')}
					tooltip={props.data.localizedCountries?.map((c) => c.name).join(', ')}
					displayId={''}
					noOfLines={1}
					ellipsisClass="columnName"
				/>
			</section>
			<section className="userlistitem grid delete">
				<MotifIconButton
					type="button"
					aria-label="delete-icon-btn"
					onClick={() => {
						props.onDeleteClick(props.data);
					}}
					className="delete-user-edit-btn"
				>
					<MotifIcon
						name="delete"
						className="delete-icon"
						iconFunction={IconoirTrash}
						title={labels.contextMenuDelete}
						size={24}
					/>
				</MotifIconButton>
			</section>
		</section>
	);
}

export default RoleRow;
